import { styled } from '@clickcease/cc-client-components-lib'

export const StyledErrorPage = styled('div', {
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
  backgroundColor: '$white',
  gap: '$10',
})

export const BrandLogoWrapper = styled('div', {
  position: 'absolute',
  top: '$10',
  left: '$20',
})

export const Title = styled('h1', {
  all: 'unset',
  fontSize: '$hxl',
  fontWeight: '$sb',
})

export const Subtitle = styled('p', {
  all: 'unset',
  textAlign: 'center',
  width: '432px',
  maxWidth: '80%',
  fontSize: '$h5',
  fontWeight: '$l',
})

export const ImageWrapper = styled('div', {
  position: 'relative',
  marginBottom: '$4',

  'svg + svg': {
    position: 'absolute',
    left: ' -110px',
    top: ' -$10',
  },
})
